<template>
  <CommunityCard>
    <div class="d-flex justify-content-between community-card-content">
      <h6>Create new</h6>

      <div class="create-forum-post-buttons d-flex">
        <div class="create-forum-post-button" @click="postModal">
          <div class="d-flex justify-content-center">
            <img src="../../assets/post.svg" alt="post" class="mr-2" />
            Post
          </div>
        </div>
        <div class="create-forum-post-button" @click="scenarioPostModal">
          <div class="d-flex justify-content-center">
            <img
              src="../../assets/nav-icons/my-scenarios.svg"
              alt="scenarios"
              class="mr-2"
            />
            Scenario
          </div>
        </div>
        <div class="create-forum-post-button" @click="mediaPostModal">
          <div class="d-flex justify-content-center">
            <img
              src="../../assets/nav-icons/my-media.svg"
              alt="media"
              class="mr-2"
            />
            Media
          </div>
        </div>
      </div>
    </div>

    <transition name="modal" v-if="currentPage !== 'none'">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog" style="max-width: 635px">
            <div class="modal-content">
              <PostDetails
                v-if="currentPage === 'create'"
                v-on:post-created="postCreated"
                v-on:post-failed="postFailed"
                :group-id="groupId"
                :is-group="isGroup"
              />
              <AttachExisting v-if="currentPage === 'attach'" />
              <UploadNew v-if="currentPage === 'upload'" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </CommunityCard>
</template>

<script>
import CommunityCard from "../CommunityCard";
import PostDetails from "@/components/CreateForumPost/PostDetails";
import AttachExisting from "@/components/CreateForumPost/AttachExisting";
import { mapState } from "vuex";
import { PAGES, POST_TYPES } from "@/store/createForumPostStore";
import UploadNew from "@/components/CreateForumPost/UploadNew";

export default {
  name: "CreateForumPost",
  props: ["isGroup", "groupId"],
  components: {
    UploadNew,
    AttachExisting,
    CommunityCard,
    PostDetails,
  },
  computed: {
    ...mapState("createForumPostStore", {
      currentPage: (state) => state.currentPage,
      postType: (state) => state.postType,
    }),
  },
  methods: {
    postCreated() {
      this.showSuccess("Post created!");
      this.$emit("reload-data");
      this.$store.dispatch("createForumPostStore/closeModal");
    },
    postFailed(errorString) {
      this.showError(errorString);
      this.$emit("reload-data");
      this.$store.dispatch("createForumPostStore/closeModal");
    },
    showSuccess(msg) {
      this.$swal.fire("Success!", msg, "success");
    },
    showError(msg) {
      this.$swal.fire("Error Posting", msg, "error");
    },
    postModal() {
      this.$store.commit("createForumPostStore/setPostType", POST_TYPES.Post);
      this.$store.commit("createForumPostStore/setCurrentPage", PAGES.Create);
    },
    scenarioPostModal() {
      this.$store.commit(
        "createForumPostStore/setPostType",
        POST_TYPES.Scenario
      );
      this.$store.commit("createForumPostStore/setCurrentPage", PAGES.Create);
    },
    mediaPostModal() {
      this.$store.commit("createForumPostStore/setPostType", POST_TYPES.Media);
      this.$store.commit("createForumPostStore/setCurrentPage", PAGES.Create);
    },
  },
};
</script>

<style>
.community-card-content {
  margin: 1rem;
}

h6 {
  margin: auto 0;
  font-weight: bolder;
  font-size: small;
}

.create-forum-post-buttons {
  margin-left: 1rem;
}

.create-forum-post-button {
  user-select: none;
  padding: 0.4rem;
  margin: 0 0 0 0.6rem;
  width: 100px;
  background: var(--isim-primary-light);
  color: var(--isim-secondary);
  font-size: small;
  font-weight: 600;
  cursor: pointer;

  transition: background 250ms ease-in-out, transform 150ms ease;
  border-radius: 8px;
}

.create-forum-post-button:hover,
.create-forum-post-button:focus {
  background: var(--isim-primary);
  color: var(--isim-primary-light);
  fill: white;
}

.create-forum-post-button img,
.create-forum-post-button img {
  filter: brightness(0) saturate(100%) invert(60%) sepia(34%) saturate(780%)
    hue-rotate(167deg) brightness(93%) contrast(81%);
}

.create-forum-post-button:hover img,
.create-forum-post-button:focus img {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) hue-rotate(193deg)
    brightness(101%) contrast(105%);
}

.create-forum-post-button:focus {
  outline: 1px solid #fff;
  outline-offset: -4px;
}

.create-forum-post-button:active {
  transform: scale(0.99);
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(244, 244, 244, 0.8);
  z-index: 999;
  overflow-y: auto;
  display: flex;
  justify-content: center;
}

.modal-wrapper {
  margin: auto 0;
  bottom: 6vh;
}

.modal-dialog {
  margin: 1rem auto !important;
  margin-top: 0 !important;
  max-height: 100%;
  height: 100%;
}

.modal-content {
  border: none;
  -webkit-box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  /* max-height: calc(100vh - 2rem) !important; */
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

.modal-content .modal-header {
  flex-shrink: 0;
}

.modal-content .modal-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .modal-dialog {
    margin: 0.5rem auto !important;
  }

  .modal-content {
    max-height: calc(100vh - 1rem) !important;
  }
}
</style>
